import { render, staticRenderFns } from "./BookAppearanceAlert.vue?vue&type=template&id=510b6079"
import script from "./BookAppearanceAlert.vue?vue&type=script&lang=js"
export * from "./BookAppearanceAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports